import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const AcademicYearDropdown = ({ options, value, onChange }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    onChange(option.value);
    setIsOpen(false);
  };

  const getLabel = () => {
    const found = options.find((opt: any) => opt.value === value);
    return found ? found.label : "Select Year";
  };

  const getOptionBackgroundColor = (option: any) => {
    return option.value === value ? "#D1D5DB" : "transparent";
  };

  return (
    <div style={{ position: "relative", paddingTop: "1rem" }}>
      <button
        className="primary-button"
        style={{
          zIndex: "1",
          padding: "12px 20px",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          fontSize: "0.875rem",
          minHeight: "40px", // ✅ match LeaderBoardDropdown
          minWidth: "180px",
          borderRadius: "34px",
          border: "1px solid #7A87F8",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
        }}
        onClick={handleClick}
      >
        {getLabel()}
        <FaChevronDown style={{ marginLeft: "8px" }} />
      </button>

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            left: "0",
            top: "100%",
            width: "100%",
            borderRadius: "0.375rem",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
            backgroundColor: "white",
            zIndex: "50",
            padding: "0",
            listStyleType: "none",
            margin: "0",
            cursor: "pointer",
          }}
        >
          {options.map((option: any, index: number) => (
            <li key={option.value}>
              <a
                onClick={() => handleOptionClick(option)}
                style={{
                  display: "block",
                  padding: "0.5rem 1rem",
                  width: "100%",
                  textAlign: "center",
                  fontSize: "0.875rem",
                  color: "#374151",
                  textDecoration: "none",
                  backgroundColor: getOptionBackgroundColor(option),
                  borderBottom:
                    index !== options.length - 1 ? "1px solid #E5E7EB" : "none",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#F3F4F6")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    getOptionBackgroundColor(option))
                }
              >
                {option.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AcademicYearDropdown;
